import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2891a31b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891a31b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2891a31b')) {
      api.createRecord('2891a31b', component.options)
    } else {
      api.reload('2891a31b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2891a31b&scoped=true&", function () {
      api.rerender('2891a31b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FKAOR5F2LF4j/JS/comp/SearchFilterTokens.vue"
export default component.exports